/**
 * @module dashboard store
 * @author Hualing Liu
 * @date 2021-10-19 19:23:05
 */
import mobx, { observable, action } from 'mobx';
import moment from 'moment';
import mobxState from '@src/store/index';

interface Iquery {
  topTab: number;
  start_datetime: string;
  end_datetime: string;
  members_uuid?: string | undefined;
  departments_uuid?: string | undefined;
  dateInfo?: string | undefined;
  dateType: number | undefined;
}

class DashboardStore {
  @observable effLoading: boolean = false;
  @observable query: Iquery = {
    topTab: 0, // 0 成员 / 1团队
    // start_datetime: '2021-10-18',
    // start_datetime: '2018-11-01',
    start_datetime: moment().format('YYYY-MM-DD'),
    end_datetime: moment().format('YYYY-MM-DD'),
    members_uuid: mobxState.monitor.user.curUserInfo.uuid,
    departments_uuid: undefined,
    dateInfo: moment().format('YYYY-MM-DD'),
    dateType: 1
  };

  @action.bound
  setQuery(data: Iquery) {
    this.query = data || {};
  }

  @action.bound
  setEffLoading(val: boolean) {
    this.effLoading = val;
  }
}

export default DashboardStore;
